(() => {
  const root = document.getElementById('vape-saloon-assistant');
  if (!root) return;
  const endpoint = root.dataset.chatEndpoint || '';
  const avatarUrl = root.dataset.avatarUrl || '';
  const shopRoot = window.Shopify?.routes?.root || '/';
  const retiredFlavourHandles = new Set([
    'elux-legend-nic-salts', 'nicohit-10ml-50-50', 'doozy-seriously-100ml-shortfills',
    'just-juice-brutal-100ml-shortfill', 'uncles-short-fills-50ml-50-50', 'uncles-short-fills-50ml-70vg'
  ]);
  const retiredRangeCollections = {
    'elux-legend-nic-salts': 'elux-legend-nic-salts',
    'nicohit-10ml-50-50': 'nicohit-10-for-20',
    'doozy-seriously-100ml-shortfills': 'doozy-seriously-100ml-shortfills',
    'just-juice-brutal-100ml-shortfill': 'just-juice-brutal-100ml-shortfill',
    'uncles-short-fills-50ml-50-50': 'uncles-shortfills-50ml-50vg-50pg',
    'uncles-short-fills-50ml-70vg': 'uncles-shortfills-50ml-70vg'
  };
  const displayVariant = (choice) => {
    if (choice?.variant !== 'Default Title') return choice?.variant || '';
    if (/^(?:titan-x-prefilled-|bash-vape-echo-pro-|ivg-nexio-10k-prefilled-)/.test(choice.handle || '')) return '20mg';
    return '';
  };
  let quickOrderRanges = [];
  try { quickOrderRanges = JSON.parse(document.getElementById('QuickOrderData')?.textContent || '{}').ranges || []; } catch (_) {}
  const history = [];
  let pending = null;
  let pendingButton = null;
  let reorderCard = null;
  let lastOrder = null;
  try { lastOrder = JSON.parse(root.querySelector('[data-last-order]')?.textContent || 'null'); } catch (_) {}

  const el = (tag, className, value) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (value) node.textContent = value;
    return node;
  };
  const setAvatar = (mark) => {
    if (!mark || !avatarUrl) return;
    const image = document.createElement('img');
    image.src = avatarUrl;
    image.alt = '';
    image.width = 160;
    image.height = 160;
    image.decoding = 'async';
    image.loading = 'lazy';
    mark.replaceChildren(image);
  };
  const launch = el('button', 'va-launch');
  launch.type = 'button';
  launch.setAttribute('aria-label', 'Open Vape Saloon assistant');
  launch.setAttribute('aria-expanded', 'false');
  launch.innerHTML = '<span class="va-launch__mark" aria-hidden="true">VS</span><span class="va-launch__text">Vape Expert<small>How can we help?</small></span>';
  setAvatar(launch.querySelector('.va-launch__mark'));
  const panel = el('section', 'va-panel');
  panel.hidden = true;
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', 'Vape Saloon assistant');
  const head = el('div', 'va-panel__head');
  head.innerHTML = '<span class="va-launch__mark" aria-hidden="true">VS</span><span class="va-panel__title"><strong>Vape Saloon assistant</strong><small>Shop faster and find help</small></span>';
  setAvatar(head.querySelector('.va-launch__mark'));
  const close = el('button', 'va-panel__close', '×');
  close.type = 'button';
  close.setAttribute('aria-label', 'Close assistant');
  head.append(close);
  const body = el('div', 'va-panel__body');
  body.innerHTML = '<div class="va-intro"><div class="va-intro__mark" aria-hidden="true">VS</div><h2>What can we help with?</h2><p>Quick access to your basket, product finder and order help.</p></div>';
  setAvatar(body.querySelector('.va-intro__mark'));
  const actions = el('div', 'va-actions');
  const status = el('p', 'va-status');
  status.setAttribute('role', 'status');
  const conversation = el('div', 'va-conversation');
  const foot = el('div', 'va-panel__foot');
  const form = el('form', 'va-form');
  const input = el('input');
  input.type = 'text'; input.maxLength = 500; input.placeholder = 'Ask about products or delivery…';
  input.setAttribute('aria-label', 'Message Vape Saloon assistant');
  const send = el('button', '', '➜');
  send.type = 'submit'; send.setAttribute('aria-label', 'Send message');
  const note = el('p', 'va-panel__note', endpoint ? 'Live availability is checked before adding. Basket discounts appear at checkout.' : 'AI chat is being set up. The quick actions above are ready to use.');
  if (!endpoint) { input.disabled = true; send.disabled = true; }
  form.append(input, send); foot.append(form, note);
  body.append(actions, status, conversation);
  panel.append(head, body, foot); root.append(launch, panel);

  const setStatus = (message) => { status.textContent = message; };
  const open = () => { panel.hidden = false; launch.hidden = true; launch.setAttribute('aria-expanded', 'true'); close.focus(); };
  const shut = () => { panel.hidden = true; launch.hidden = false; launch.setAttribute('aria-expanded', 'false'); launch.focus(); };
  launch.addEventListener('click', open);
  document.querySelectorAll('[data-vs-assistant-open]').forEach((trigger) => trigger.addEventListener('click', open));
  close.addEventListener('click', shut);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !panel.hidden) shut(); });
  const action = (title, detail, handler) => {
    const button = el('button', 'va-action'); button.type = 'button';
    button.append(el('span', '', title), el('small', '', detail));
    button.addEventListener('click', handler); actions.append(button);
  };
  action('↻  Repeat my last order', 'Review current items and prices before adding', () => { showLastOrder(); });
  action('⌕  Find flavours and products', 'Open Quick Order to search ranges and strengths', () => {
    shut(); const trigger = document.querySelector('[data-quick-order-open]');
    if (trigger) trigger.click(); else window.location.href = '/search';
  });
  action('▣  Where is my order?', 'Open Shopify’s verified order status', () => { showOrderStatus(); });
  action('✉  Contact the team', 'Ask us for help with an order or product', () => { window.location.href = '/pages/contact-us'; });

  const thinking = el('div', 'va-thinking');
  thinking.setAttribute('role', 'status');
  thinking.setAttribute('aria-live', 'polite');
  thinking.setAttribute('aria-atomic', 'true');
  const thinkingAvatar = el('span', 'va-thinking__avatar', 'VS');
  thinkingAvatar.setAttribute('aria-hidden', 'true');
  setAvatar(thinkingAvatar);
  const thinkingBubble = el('span', 'va-thinking__bubble');
  const thinkingText = el('span', 'va-thinking__text');
  const thinkingDots = el('span', 'va-thinking__dots');
  thinkingDots.setAttribute('aria-hidden', 'true');
  for (let dot = 0; dot < 3; dot += 1) thinkingDots.append(el('span'));
  thinkingBubble.append(thinkingText, thinkingDots);
  thinking.append(thinkingAvatar, thinkingBubble);
  const thinkingTopics = [
    { pattern: /\b(order|tracking|track|parcel|where is my)\b/i, lines: ['Let me find the right order help…', 'I’ll look at your order options…'] },
    { pattern: /\b(delivery|shipping|dispatch|postage|arriv\w*|ship)\b/i, lines: ['Let me check the delivery details…', 'I’ll look into the delivery options…'] },
    { pattern: /\b(stock|available|availability|sold out|in store)\b/i, lines: ['I’ll check what’s available…', 'Let me look at current availability…'] },
    { pattern: /\b(offer|deal|discount|multi.?buy|4 for|10 for|price|cost)\b/i, lines: ['Let me check the current offers…', 'I’ll look at the pricing for you…'] },
    { pattern: /\b(flavo[u]?r|e-?liquid|nic salt|juice|shortfill|nicohit|elux|elfliq|doozy|bar juice|vampire vape)\b/i, lines: ['Let me find the right flavours…', 'I’ll look through the liquids for you…'] },
    { pattern: /\b(kit|device|vape pen|starter)\b/i, lines: ['Let me check the kit options…', 'I’ll find a suitable device…'] },
    { pattern: /\b(coil|pod|cartridge|replacement|compatible|fit)\b/i, lines: ['I’ll check which parts fit…', 'Let me look up the replacements…'] },
    { pattern: /\b(add|basket|cart|buy)\b/i, lines: ['Let me check that before adding it…', 'I’ll check the basket option…'] }
  ];
  const generalThinking = ['Let me look into that for you…', 'I’ll check that for you…', 'One moment while I look into it…'];
  let thinkingTurn = 0;
  let lastThinkingLine = '';
  const showThinking = (message) => {
    const lines = thinkingTopics.find(topic => topic.pattern.test(message))?.lines || generalThinking;
    let line = lines[thinkingTurn % lines.length];
    thinkingTurn += 1;
    if (line === lastThinkingLine && lines.length > 1) line = lines[thinkingTurn % lines.length];
    lastThinkingLine = line;
    thinkingText.textContent = line;
    conversation.append(thinking);
    panel.classList.add('va-panel--thinking');
    body.scrollTop = body.scrollHeight;
  };
  const hideThinking = () => {
    thinking.remove();
    panel.classList.remove('va-panel--thinking');
  };
  const addMessage = (text, role) => {
    if (role === 'assistant') hideThinking();
    conversation.append(el('div', `va-message va-message--${role}`, text));
    history.push({ role, text });
    if (history.length > 12) history.shift();
    body.scrollTop = body.scrollHeight;
  };
  const money = (pence) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(pence / 100);
  const optionKey = value => String(value || '').normalize('NFKD').toLowerCase()
    .replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
  const currentMatchForRetired = item => {
    const range = quickOrderRanges.find(candidate => candidate.handle === retiredRangeCollections[item.handle]);
    const oldOption = optionKey(item.variant);
    if (!range || !oldOption || oldOption === 'default title') return null;
    const matches = (range.variants || []).filter(variant =>
      optionKey(`${variant.flavour}${variant.strength ? ` / ${variant.strength}` : ''}`) === oldOption);
    if (matches.length !== 1) return null;
    const match = matches[0];
    const url = String(match.url || '').match(/^\/products\/([a-z0-9-]+)\?variant=(\d+)$/);
    if (!url || String(match.id) !== url[2] || retiredFlavourHandles.has(url[1])) return null;
    return { id: url[2], handle: url[1], url: `/products/${url[1]}` };
  };
  const showSignIn = (purpose) => {
    if (reorderCard) reorderCard.remove();
    const card = el('div', 'va-order-card');
    card.append(el('strong', '', purpose === 'repeat' ? 'Sign in to repeat an order' : 'Find your order securely'),
      el('span', '', purpose === 'repeat'
        ? 'Sign in with the email used at checkout. Shopify will then show your last order for review.'
        : 'Sign in to see your orders, or use the order-status link in your confirmation email. Shopify may ask you to verify your details.'));
    const link = el('a', 'va-basket-link', 'Open Shopify account');
    link.href = `${shopRoot}account`;
    card.append(link); conversation.append(card);
    reorderCard = card;
    body.scrollTop = body.scrollHeight;
  };
  const showOrderStatus = () => {
    if (!lastOrder) { showSignIn('status'); return; }
    if (reorderCard) { reorderCard.remove(); reorderCard = null; }
    const card = el('div', 'va-order-card');
    card.append(el('strong', '', `Order ${lastOrder.number}`),
      el('span', '', `Placed ${lastOrder.date || 'previously'} · Status when this page loaded: ${lastOrder.fulfillment || 'Check order status'}`));
    const link = el('a', 'va-basket-link', 'View secure order status');
    link.href = lastOrder.statusUrl || lastOrder.accountUrl || `${shopRoot}account`;
    card.append(link);
    card.append(el('small', '', 'Shopify may ask you to sign in or verify your order before showing tracking details.'));
    conversation.append(card);
    body.scrollTop = body.scrollHeight;
  };
  const loadReorder = async () => {
    const productRequests = new Map();
    return Promise.all((lastOrder.items || []).map(async item => {
      const row = { id: String(item.id), title: item.title, variant: item.variant,
        quantity: Number(item.quantity), handle: item.handle, available: false, checked: false, price: null };
      if (!row.handle || !row.id || !Number.isInteger(row.quantity) || row.quantity < 1) return row;
      if (retiredFlavourHandles.has(row.handle)) {
        const match = currentMatchForRetired(item);
        row.checked = true;
        if (!match) { row.note = 'No exact current flavour and strength match'; return row; }
        row.original = `${item.title}${item.variant && item.variant !== 'Default Title' ? ` — ${item.variant}` : ''}`;
        row.id = match.id; row.handle = match.handle; row.url = match.url;
      }
      try {
        if (!productRequests.has(row.handle)) {
          productRequests.set(row.handle, fetch(`${shopRoot}products/${encodeURIComponent(row.handle)}.js`,
            { cache: 'no-store' }).then(response => {
            if (!response.ok) throw new Error('Product unavailable');
            return response.json();
          }));
        }
        const product = await productRequests.get(row.handle);
        if (product.handle && product.handle !== row.handle) return row;
        row.checked = true;
        const variant = (product.variants || []).find(v => String(v.id) === row.id);
        if (variant?.available && !variant.requires_selling_plan) {
          row.available = true; row.price = Number(variant.price);
          row.variant = variant.title;
          row.title = product.title;
        }
      } catch (_) {}
      return row;
    }));
  };
  const reorderFingerprint = rows => JSON.stringify(rows.map(row => [row.handle, row.id, row.checked, row.available, row.price]));
  const showReorderCard = (rows, notice = '') => {
    if (reorderCard) reorderCard.remove();
    const card = el('div', 'va-order-card');
    card.append(el('strong', '', `Repeat order ${lastOrder.number}`));
    card.append(el('small', '', 'These are current listed prices. Basket offers and delivery are calculated in Shopify.'));
    if (notice) card.append(el('p', 'va-order-notice', notice));
    const list = el('div', 'va-order-items');
    rows.forEach(row => {
      const line = el('div', 'va-order-item');
      line.append(el('span', '', `${row.quantity} × ${row.title}${row.variant && row.variant !== 'Default Title' ? ` — ${row.variant}` : ''}`),
        el('strong', '', row.available ? money(row.price * row.quantity) : row.checked ? 'Unavailable' : 'Could not check'));
      if (row.original) {
        line.append(el('small', '', `Current exact match for ${row.original}`));
        const link = el('a', 'va-basket-link', 'View current flavour page');
        link.href = `${shopRoot}${row.url.slice(1)}`;
        line.append(link);
      } else if (row.note) line.append(el('small', '', row.note));
      list.append(line);
    });
    card.append(list);
    const available = rows.filter(row => row.available);
    if (available.length) {
      const total = available.reduce((sum, row) => sum + row.price * row.quantity, 0);
      card.append(el('span', 'va-order-total', `Available items: ${money(total)} before offers`));
      const button = el('button', 'va-order-confirm', `Add ${available.reduce((n, row) => n + row.quantity, 0)} available item(s) to basket`);
      button.type = 'button';
      button.addEventListener('click', async () => {
        button.disabled = true; setStatus('Checking prices and availability again…');
        const fresh = await loadReorder();
        if (reorderFingerprint(fresh) !== reorderFingerprint(rows)) {
          showReorderCard(fresh, 'Availability or prices changed. Please review the updated order before adding.');
          setStatus(''); return;
        }
        try {
          const response = await fetch(`${shopRoot}cart/add.js`, { method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: available.map(row => ({ id: Number(row.id), quantity: row.quantity })) }) });
          if (!response.ok) {
            const problem = await response.json().catch(() => ({}));
            throw new Error(problem.description || 'Shopify could not add one or more items.');
          }
          setStatus('Available items added to your basket. Shopify will show any multi-buy offers there.');
          if (reorderCard) { reorderCard.remove(); reorderCard = null; }
          const link = el('a', 'va-basket-link', 'View basket');
          link.href = `${shopRoot}cart`; conversation.append(link);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (error) {
          setStatus(`Could not add the order: ${error.message}`);
          button.disabled = false;
        }
      });
      card.append(button);
    } else card.append(el('small', '', 'No items could be confirmed as available right now.'));
    conversation.append(card);
    reorderCard = card;
    body.scrollTop = body.scrollHeight;
  };
  const showLastOrder = async () => {
    if (!lastOrder) { showSignIn('repeat'); return; }
    setStatus('Checking your last order against current products…');
    const rows = await loadReorder();
    setStatus('');
    if (!rows.length) { setStatus('Your last order has no products available to repeat.'); return; }
    showReorderCard(rows);
  };
  const confirmAdd = async () => {
    if (!pending) return;
    const choice = pending;
    pending = null;
    if (pendingButton) { pendingButton.remove(); pendingButton = null; }
    setStatus('Checking current availability…');
    try {
      if (retiredFlavourHandles.has(choice.handle)) throw new Error('This range has moved to individual flavour pages. Please choose a current flavour.');
      const productResponse = await fetch(`${shopRoot}products/${encodeURIComponent(choice.handle)}.js`, { cache: 'no-store' });
      if (!productResponse.ok) throw new Error('We could not check this product.');
      const product = await productResponse.json();
      if (product.handle && product.handle !== choice.handle) throw new Error('This product page has changed. Please choose the current flavour.');
      const variant = (product.variants || []).find(v => String(v.id) === String(choice.id));
      if (!variant?.available || variant.requires_selling_plan) {
        addMessage('That option is no longer available to order. Please choose another flavour or strength.', 'assistant');
        setStatus(''); return;
      }
      if (Number(variant.price) !== Number(choice.price)) {
        pending = { ...choice, price: Number(variant.price) };
        addMessage(`The price has changed to ${money(variant.price)} each. Reply yes to add ${choice.quantity}, or choose another option.`, 'assistant');
        setStatus(''); return;
      }
      const response = await fetch(`${shopRoot}cart/add.js`, { method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(choice.id), quantity: choice.quantity }] }) });
      if (!response.ok) {
        const problem = await response.json().catch(() => ({}));
        throw new Error(problem.description || 'Shopify could not add this option.');
      }
      const variantLabel = displayVariant(choice);
      addMessage(`Added ${choice.quantity} × ${choice.product}${variantLabel ? ` — ${variantLabel}` : ''} to your basket. You can keep shopping or view your basket.`, 'assistant');
      const link = el('a', 'va-basket-link', 'View basket');
      link.href = `${shopRoot}cart`;
      conversation.append(link);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setStatus('');
    } catch (error) {
      addMessage(`I could not add that item: ${error.message}`, 'assistant');
      setStatus('');
    }
  };
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const message = input.value.trim();
    if (!endpoint || !message) return;
    input.value = '';
    const priorHistory = history.slice(-8);
    addMessage(message, 'user');
    if (pending && /^(yes|yep|yeah|confirm|add it|add to (my )?basket)([!., ]|$)/i.test(message)) {
      showThinking('add to basket');
    } else if (!pending || !/^(no|cancel|stop)([!., ]|$)/i.test(message)) {
      showThinking(message);
    }
    input.disabled = send.disabled = true;
    try {
      if (pending && /^(yes|yep|yeah|confirm|add it|add to (my )?basket)([!., ]|$)/i.test(message)) {
        await confirmAdd();
      } else if (pending && /^(no|cancel|stop)([!., ]|$)/i.test(message)) {
        pending = null;
        if (pendingButton) { pendingButton.remove(); pendingButton = null; }
        addMessage('Okay, I have not added it. What would you like instead?', 'assistant');
      } else {
        pending = null;
        if (pendingButton) { pendingButton.remove(); pendingButton = null; }
        const response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ message, history: priorHistory }) });
        if (!response.ok) throw new Error('The assistant is unavailable right now.');
        const result = await response.json();
        addMessage(result.reply || 'Sorry, I could not answer that.', 'assistant');
        if (result.proposal) {
          pending = result.proposal;
          const card = el('div', 'va-proposal');
          const variantLabel = displayVariant(pending);
          card.append(el('strong', '', `${pending.quantity} × ${pending.product}${variantLabel ? ` — ${variantLabel}` : ''}`),
            el('span', '', `${money(pending.price)} each · ${money(pending.price * pending.quantity)} before any basket offer`));
          const button = el('button', '', 'Add to basket');
          button.type = 'button';
          button.addEventListener('click', async () => { button.disabled = true; showThinking('add to basket'); await confirmAdd(); button.remove(); });
          pendingButton = button;
          card.append(button);
          if (pending.url && /^\/products\/[a-z0-9-]+$/.test(pending.url) && !retiredFlavourHandles.has(pending.handle)) {
            const productLink = el('a', 'va-product-link', 'View current flavour page');
            productLink.href = `${shopRoot}products/${encodeURIComponent(pending.handle)}`;
            card.append(productLink);
          }
          conversation.append(card);
          addMessage('Reply yes or use Add to basket to confirm.', 'assistant');
        }
      }
    } catch (_) { addMessage('The assistant is unavailable right now. Please use the contact link above.', 'assistant'); }
    hideThinking();
    input.disabled = send.disabled = false; input.focus();
  });
})();
